import { Option } from '@/common/types/option'

export const MISSION_PROVIDER_LABELS: Record<string, string> = {
  'Tmais::Missions::Providers::AcceptProvider': 'Completar missao assim que iniciada',
  'Tmais::Missions::Providers::RedeemQuantityProvider': 'Resgatar recompensa (Qtd.)',
  'Tmais::Missions::Providers::ConsumeTotalAmountProvider': 'Consumir valor total (R$)',
  'Tmais::Missions::Providers::InviteNewUsersProvider': 'Convidar novos usuarios',
}

export const MISSION_PROVIDER_FALLBACK_DATA = [
  {
    provider_klass: 'Tmais::Missions::Providers::AcceptProvider',
    display_name: 'Completar missao assim que iniciada',
    description:
      'O participante finaliza a missao imediatamente apos aceita-la. Ideal para fluxos introdutorios.',
  },
  {
    provider_klass: 'Tmais::Missions::Providers::RedeemQuantityProvider',
    display_name: 'Completar missao quando o usuario resgatar uma recompensa um determinado numero de vezes.',
    description:
      'O requisito e concluido quando o usuario resgata uma quantidade minima de recompensas elegiveis.',
  },
  {
    provider_klass: 'Tmais::Missions::Providers::ConsumeTotalAmountProvider',
    display_name: 'Completar missao quando o usuario consumir o valor em R$.',
    description:
      'O requisito e concluido quando o usuario consome um valor igual ou superior ao configurado.',
  },
  {
    provider_klass: 'Tmais::Missions::Providers::InviteNewUsersProvider',
    display_name: 'Completar missao quando o usuario convidar o numero especificado de usuarios.',
    description:
      'O requisito e concluido quando o usuario convida e converte a quantidade minima de novos usuarios.',
  },
] as const

export const MISSION_PROVIDER_FALLBACK_OPTIONS: Option[] = MISSION_PROVIDER_FALLBACK_DATA.map(
  ({ provider_klass, display_name }) => ({
    value: provider_klass,
    label: display_name,
  }),
)
